import type { ReactNode } from "react";
import {
  Camera,
  Flame,
  Heart,
  IceCream,
  Info,
  RefreshCw,
  ShieldCheck,
  Sparkles,
  Sprout,
} from "lucide-react";
import type {
  AttentionBannerActionIcon,
  AttentionBannerKind,
} from "./attention-banner";

export const BANNER_KIND_ICON: Record<AttentionBannerKind, ReactNode> = {
  reactivation: <Sprout className="size-5" aria-hidden />,
  momentum: <Sprout className="size-5" aria-hidden />,
  day1: <Sparkles className="size-5" aria-hidden />,
  day2: <Sparkles className="size-5" aria-hidden />,
};

export const BANNER_ACTION_ICON: Record<AttentionBannerActionIcon, ReactNode> =
  {
    ice_cream: <IceCream className="size-4" aria-hidden />,
    heart: <Heart className="size-4" aria-hidden />,
    shield: <ShieldCheck className="size-4" aria-hidden />,
    sparkles: <Sparkles className="size-4" aria-hidden />,
    swap: <RefreshCw className="size-4" aria-hidden />,
    share: <Camera className="size-4" aria-hidden />,
    tips: <Info className="size-4" aria-hidden />,
    hot_takes: <Flame className="size-4" aria-hidden />,
  };
